'use client';

import { useEffect, useState } from 'react';
import CookieDrawer from './cookie-drawer';

export default function CookieDrawerContainer() {
  const [drawerPortal, setDrawerPortal] = useState<HTMLElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [render, setRender] = useState(false);

  useEffect(() => {
    const hasConsented = localStorage.getItem('cookieConsent');
    if (!hasConsented) {
      setRender(true);
      setIsOpen(true);
    }
  }, []);

  useEffect(() => {
    setDrawerPortal(document.getElementById('cookie-drawer-portal'));
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsOpen(false);
  };

  return (
    <CookieDrawer
      render={render}
      drawerPortal={drawerPortal}
      isOpen={isOpen}
      onAccept={handleAccept}
    />
  );
}
